import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DetalleSolicitudMultiComponent } from './components/individual-retreat/request-list-notifi/DetalleSolicitudMulti/detalleSolicitudMulti.component';
import { MultiBeneficiarioComponent } from './components/individual-retreat/request-list-notifi/multibeneficiario/multibeneficiario.component';
import { LoginComponent } from './components/login/login.component';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { RoutingPath } from './configs/routing-path';
import { LoggedInGuard } from './core/guards/logged-in/logged-in.guard';
import { NoLoggedGuard } from './core/guards/no-logged/no-logged.guard';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    redirectTo: RoutingPath.appRouting.components.dashboard.path + '/' + RoutingPath.appRouting.components.dashboard.pages.home.path,
    pathMatch: 'full',
  },
  {
    path: RoutingPath.appRouting.components.dashboard.path,
    redirectTo: RoutingPath.appRouting.components.dashboard.path + '/' + RoutingPath.appRouting.components.dashboard.pages.home.path,
    pathMatch: 'prefix'
  },
  {
    path: RoutingPath.appRouting.components.invidivual_affiliation.path,
    redirectTo: RoutingPath.appRouting.components.invidivual_affiliation.path + '/' + RoutingPath.appRouting.components.invidivual_affiliation.pages.home.path,
    pathMatch: 'prefix',
  },
  {
    path: RoutingPath.appRouting.components.mass_affiliation.path,
    redirectTo: RoutingPath.appRouting.components.mass_affiliation.path + '/' + RoutingPath.appRouting.components.mass_affiliation.pages.home.path,
    pathMatch: 'prefix'
  },
  {
    path: RoutingPath.appRouting.components.individual_retreat.path,
    redirectTo: RoutingPath.appRouting.components.individual_retreat.path + '/' + RoutingPath.appRouting.components.individual_retreat.pages.home.path,
    pathMatch: 'prefix',
  },
  {
    path: RoutingPath.appRouting.components.beneficiary_removal.path,
    redirectTo: RoutingPath.appRouting.components.beneficiary_removal.path + '/' + RoutingPath.appRouting.components.beneficiary_removal.pages.home.path,
    pathMatch: 'prefix',
  },
  {
    path: RoutingPath.appRouting.components.mass_retreat.path,
    redirectTo: RoutingPath.appRouting.components.mass_retreat.path + '/' + RoutingPath.appRouting.components.mass_retreat.pages.home.path,
    pathMatch: 'prefix'
  },

  {
    path: RoutingPath.appRouting.components.acreditacion_cuota.path,
    redirectTo: RoutingPath.appRouting.components.acreditacion_cuota.path + '/' + RoutingPath.appRouting.components.acreditacion_cuota.pages.home.path,
    pathMatch: 'prefix',
  },
  {
    path: RoutingPath.appRouting.components.discapacidad.path,
    redirectTo: RoutingPath.appRouting.components.discapacidad.path + '/' + RoutingPath.appRouting.components.discapacidad.pages.home.path,
    pathMatch: 'prefix',
  },
  {
    path: 'iPlanetDirectoryPro/:idToken',
    canActivate: [NoLoggedGuard],
    component: NotAuthorizedComponent
  },
  {
    path: 'no-autorizado',
    component: NotAuthorizedComponent,
    canActivate: [NoLoggedGuard],
  },
  {
    path: RoutingPath.appRouting.components.dashboard.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/dashboard/dashboard.module#DashboardModule'
  },
  {
    path: RoutingPath.appRouting.components.business_information.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/business-information/business-information.module#BusinessInformationModule'
  },
   {
    path: RoutingPath.appRouting.components.acreditacion_cuota.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/acreditacion-cuota-monetaria/acreditacion-cuota-monetaria.module#AcreditacionCuotaMonetariaModule'
  },
   {
    path: RoutingPath.appRouting.components.discapacidad.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/discapacidad/discapacidad.module#DiscapacidadModule'
  },
  {
    path: RoutingPath.appRouting.components.invidivual_affiliation.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/individual-affiliation/individual-affiliation.module#IndividualAffiliationModule'
  },
  {
    path: RoutingPath.appRouting.components.mass_affiliation.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/mass-affiliation/mass-affiliation.module#MassAffiliationModule'
  },
  {
    path: RoutingPath.appRouting.components.individual_retreat.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/individual-retreat/individual-retreat.module#IndividualRetreatModule'
  },
  {
    path: RoutingPath.appRouting.components.afiliate_beneficiary.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/individual-afiliate-beneficiary/individual-afiliate-beneficiary.module#IndividualAfiliateBeneficiaryModule'
  },
  {
    path: RoutingPath.appRouting.components.beneficiary_removal.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/beneficiary-removal/beneficiary-removal.module#BeneficiaryRemovalModule'
  },
  {
    path: RoutingPath.appRouting.components.mass_retreat.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/mass-retreat/mass-retreat.module#MassRetreatModule'
  },
  {
    path: RoutingPath.appRouting.components.workers_information.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/workers-information/workers-information.module#WorkersInformationModule'
  },
  {
    path: RoutingPath.appRouting.components.workers_information.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/cambio-estado-civil/cambio-estado-civil.module#ChangeMaritalStatusModule'
  },
  {
    path: RoutingPath.appRouting.components.user.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/user/user.module#UserModule'
  },
  {
    path: RoutingPath.appRouting.components.certificates.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/certificates/certificates.module#CertificatesModule'
  },{
    path: RoutingPath.appRouting.components.affiliates_process.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/affiliates/affiliates.module#AffiliatesModule'
  },{
    path: RoutingPath.appRouting.components.pqrs.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/pqrs/pqrs.module#PqrsModule',
    data: {
      breadcrumb: RoutingPath.appRouting.components.pqrs.breadcrumb
    }
  },
  {
    path: RoutingPath.appRouting.components.mass_queries.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/mass-queries/mass-queries.module#MassQueriesModule'
  },
  {
    path: RoutingPath.appRouting.components.subsidy.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/subsidy/subsidy.module#SubsidyModule'
  },
  {
    path: RoutingPath.appRouting.components.disaffiliate_query.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/disaffiliate-query/disaffiliate-query.module#DisaffiliateQueryModule'
  },
  {
    path: RoutingPath.appRouting.components.affiliate_query.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: './components/disaffiliate-query/disaffiliate-query.module#DisaffiliateQueryModule'
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'multi-beneficiarios/:code',
        component: MultiBeneficiarioComponent 
      },
    ]
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'detalle-solicitud/:id',
        component: DetalleSolicitudMultiComponent 
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
